// extracted by mini-css-extract-plugin
export default {"cart-button":"CartButton_cart-button__8SWn4","svg-icon":"CartButton_svg-icon__wPnxH"};